export default __webpack_public_path__ + "maps-examples-camera-animation-thumbnail-480-59d18f7c112799637870cbdb8a3ae2b6.png";